import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20illustration%20of%20dramatic%20spotlights%20and%20city%20night%20reflections%2C%20deep%20crimson%20and%20warm%20amber%20tones%2C%20cinematic%20grainy%20texture%2C%20moody%20atmosphere%2C%20no%20people&width=1600&height=1000&seq=heliao51-hero-01&orientation=landscape"
          alt="黑料51 吃瓜热点现场主视觉"
          title="黑料51 吃瓜热点 现场爆料 主视觉"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="mx-auto max-w-5xl text-center">
          <span className="animate-hero-rise inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs md:text-sm text-background-50 backdrop-blur">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-live-line text-accent-300" />
            </span>
            今日速递已更新至 13:15 · 新料连更中
          </span>

          <h1
            className="animate-hero-rise mt-8 font-heading text-4xl font-black tracking-tight text-background-50 md:text-6xl"
            style={{ animationDelay: '0.1s' }}
          >
            黑料51
          </h1>

          <p
            className="animate-hero-rise mx-auto mt-6 max-w-3xl text-base leading-relaxed text-background-100 md:text-xl"
            style={{ animationDelay: '0.2s' }}
          >
            黑料51吃瓜热点 · 黑料51现场爆料 · 新料速递式滚动更新
          </p>
          <p
            className="animate-hero-rise mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base"
            style={{ animationDelay: '0.3s' }}
          >
            进来就能跟着看现场。吃瓜围观、现场有图有料，最新方向不遮掩，把当天散落的线索按时间收在一条线上。
          </p>

          <div
            className="animate-hero-rise mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row"
            style={{ animationDelay: '0.4s' }}
          >
            <a
              href="#hot"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-base font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto cursor-pointer"
            >
              <i className="ri-fire-line" />
              看今日吃瓜热点
            </a>
            <a
              href="#onsite"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 bg-white/10 px-6 py-3.5 text-base font-medium text-background-50 backdrop-blur transition-colors hover:bg-white/20 sm:w-auto cursor-pointer"
            >
              <i className="ri-camera-lens-line" />
              直达现场爆料
            </a>
          </div>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 md:mt-20 md:grid-cols-4 md:gap-5">
          {heroStats.map((stat) => (
            <div
              key={stat.id}
              className="rounded-lg border border-white/15 bg-white/10 px-4 py-5 text-center backdrop-blur md:px-5"
            >
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-sm font-medium text-accent-300">{stat.unit}</span>
              </p>
              <p className="mt-2 text-xs text-background-200 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}